import "./Coursetable.css";
import { useEffect, useState } from "react";



function CourseTable({ searchQuery = "", filterMode = "All" }) {

  const API = "http://localhost:3001/courses";
const [courses, setCourses] = useState([]);
useEffect(() => {
  fetchCourses();
}, []);

const fetchCourses = async () => {
  try {
    const res = await fetch(API);
    const data = await res.json();
setCourses(
  data.filter(course => course.status === "Published")
);
  } catch (err) {
    console.log(err);
  }
};
const filteredCourses = courses.filter((course) => {

  const matchesSearch =
    course.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
    course.category.toLowerCase().includes(searchQuery.toLowerCase()) ||
    course.duration.toLowerCase().includes(searchQuery.toLowerCase());

  const matchesFilter =
    filterMode === "All" ||
    course.status === filterMode;

  return matchesSearch && matchesFilter;

});
  return (
    <div id="student-courses" className="student-page-coursetable-section" data-aos="fade-up" data-aos-duration="700">
      <div className="student-page-coursetable-header" data-aos="fade-down" data-aos-delay="80" data-aos-duration="600">
        <h2>Available Courses</h2>
        <button className="student-page-coursetable-view-button">View All</button>
      </div>

      <div className="student-page-coursetable-table-container" data-aos="fade-up" data-aos-delay="120" data-aos-duration="650">
        <table>
          <thead>
            <tr>
              <th>Course</th>
              <th>Duration</th>
              <th>Fees</th>
              <th>Mode</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {filteredCourses.map((course) => (
              <tr key={course.id}>
                <td>{course.title}</td>
                <td>{course.duration}</td>
                <td>₹ {course.price}</td>
<td>
<span className="student-page-coursetable-mode">
{course.status}
</span>
</td>
                <td>
                  <button className="student-page-coursetable-enroll-button">Enroll</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default CourseTable;
